// Taxonomy label localization (Approach A: static client-side overlays).
//
// The whole taxonomy is fetched once and held in App state (fetchTaxonomy).
// These helpers overlay localized `name` values by slug, falling back to the
// en-GB source name the DB returns. Report read paths (reports_in_bounds etc.)
// return category_slug, so localizeCategoryName resolves list/marker labels.
//
// Overlays are compiled from locales/<locale>/taxonomy.yml by
// scripts/taxonomy-i18n.js at build time. Adding a locale = dropping in a YAML
// file + a common.json catalog + an entry in SUPPORTED_LOCALES.

import enUS from '../locales/en-US/taxonomy.json';

const OVERLAYS = {
  'en-US': enUS,
};

export function localizeCategoryName(slug, locale) {
  return OVERLAYS[locale]?.categories?.[slug] ?? null;
}

export function localizeCollectionName(slug, locale) {
  return OVERLAYS[locale]?.collections?.[slug] ?? null;
}

/** Returns a new taxonomy tree with localized names (source name as fallback). */
export function localizeTaxonomy(taxonomy, locale) {
  if (!locale || !OVERLAYS[locale]) return taxonomy;
  const overlay = OVERLAYS[locale];
  return taxonomy.map((col) => ({
    ...col,
    name: overlay.collections?.[col.slug] ?? col.name,
    categories: col.categories.map((cat) => ({
      ...cat,
      name: overlay.categories?.[cat.slug] ?? cat.name,
    })),
  }));
}
